import { ComponentConfiguration } from '@configs/types'
import { useConfigurationStore } from '@stores/configurationStore'
import { Slot } from '@utils/Slot'
import clsx from 'clsx'
import React, { ReactNode } from 'react'
import { ViewportType } from 'game-ui-types'
import { ICommonJackpotConfig } from './types'

interface JackpotStatisticsProps {
    globalConfigPositions: ComponentConfiguration['position'] // Config depending on game UI configuration
    config: ICommonJackpotConfig // Jackpot specific config
    children: ReactNode[]
}

/**
 * JackpotStatistics Component
 *
 * Handles template of all jackpot statistic panels split in two rows and a logo in the middle in portrait, and all in a row in landscape.
 * "top", "bottom" and "logo" Slots available so specific statistics item panels are rendered according to jackpot.
 */
const JackpotStatistics: React.FC<JackpotStatisticsProps> = ({ globalConfigPositions, children }) => {
    const viewport = useConfigurationStore((state) => state.viewport)
    const jackpotCardsTopRowConfigStyles = useConfigurationStore(
        (state) => state.getComponentConfig('JackpotCardsTopRow').styles
    )

    const jackpotStatsClasses = clsx('absolute w-full h-auto', {
        'flex justify-between': viewport !== ViewportType.MOBILE_PORTRAIT,
    })

    const jackpotStatsStyle = {
        padding: `${globalConfigPositions?.top ?? 0} ${globalConfigPositions?.right ?? 0} 0 ${globalConfigPositions?.left ?? 0}`,
    }

    const topRowClasses = clsx('flex w-full z-[3] relative', jackpotCardsTopRowConfigStyles ?? '', {
        'justify-between w-full': viewport === ViewportType.MOBILE_PORTRAIT,
    })

    const bottomRowClass = clsx('flex w-full z-[2] relative', {
        'justify-end': viewport !== ViewportType.MOBILE_PORTRAIT,
        'justify-between': viewport === ViewportType.MOBILE_PORTRAIT,
    })

    return (
        <div className={jackpotStatsClasses} style={jackpotStatsStyle}>
            <div className={topRowClasses}>
                <Slot slot="top">{children}</Slot>
            </div>

            <Slot slot="logo">{children}</Slot>

            <div className={bottomRowClass}>
                <Slot slot="bottom">{children}</Slot>
            </div>
        </div>
    )
}

export default JackpotStatistics
